<template>
    <div class="flex flex-col">
        <h2 class="text-2xl md:text-4xl font-semibold mb-6">
            Kidney Function Throughout the Patient's Management Journey
        </h2>

        <ul class="list-disc pl-4 font-light mb-6">
            <li>
                Kidney function and CaOx crystal deposition in the kidney allograft gradually worsened despite
                conservative treatment post-PH1 diagnosis including continuous kidney replacement therapy and intensive
                hemodialysis
            </li>
            <li>Conservative treatments included high fluid intake, avoidance of high-oxalate foods, and vitamin B6</li>
        </ul>

        <h3 class="text-2xl font-semibold text-center">
            Change in serum creatinine and eGFR, and management strategies utilized in the patient
        </h3>

        <img
            src="@/assets/img/graphics/transplant/kidney-function.svg"
            alt="Change in Serum creatinine"
            class="block object-contain w-full mt-6 p-0 sm:p-16"
        />
    </div>
</template>
